import { connect } from 'react-redux';

import Actions from '../../Actions/Creators';
import Auth from './Component/Auth';


const mapStateToProps = (state, ownProps) => ({

    isLoading: state.auth.isComponentLoading,

    loginError: state.auth.loginError,
    loginErrorCode: state.auth.loginErrorCode,
    loginMessage: state.auth.loginMessage,

    emailVerified: state.auth.emailVerified,
    emailAvailable: state.auth.ckeckEmailStatus,

    phoneVerified: state.auth.phoneVerified,
    phoneAvailable: state.auth.checkPhoneStatus,
    phoneMeta: state.auth.checkPhoneStatusMeta || {},

    activationVerified: state.auth.activationVerified,
    activationAvailable: state.auth.checkActivationStatus,

    checkValidationResponseType: state.auth.checkValidationResponseType,

    isMagicLinkUsed:  state.auth.isMagicLinkUsed,
    isMagicLinkSuccess:  state.auth.isMagicLinkSuccess,

    isInvitationLinkUsed: state.auth.isInvitationLinkUsed,
    isInvitationLinkSuccess: state.auth.isInvitationLinkSuccess,
    isInvitationLinkFailed: state.auth.isInvitationLinkFailed,
    invitationUserDetails: state.auth.invitationUserDetails || {},
    invitationUserAssociations: state.auth.invitationUserAssociations,
    invitationLink: state.auth.invitationLink,
    showInvitationLinkModal: state.auth.showInvitationLinkModal,

    otpVerified: state.verifyOtp.status,
    otpError: state.verifyOtp.error,
    otpLoading: state.verifyOtp.isLoading,
    otpSent: state.verifyOtp.sendOtpStatus,
    loginMessage: state.auth.loginMessage

});


const mapDispatchToProps = (dispatch) => ({

    loginUser: (payload, persistent, isGuest) => dispatch(Actions.loginUser(payload, persistent, isGuest)),

    // signupUser: (payload) => dispatch(Actions.signupUser(payload)),
    signupUserV2: (payload, otpInfo) => dispatch(Actions.signupUserV2(payload, otpInfo)),

    // signupUserV2_1: (payload) => dispatch(Actions.signupUserV2_1(payload)),

    checkEmailAvailability: (email) => dispatch(Actions.checkEmailAvailability(email)),
    checkPhoneNumberAvailability: (phone) => dispatch(Actions.checkPhoneNumberAvailability(phone)),
    checkActivationCodeAvailability: (code) => dispatch(Actions.checkActivationCodeAvailability(code)),

    sendOtp: (username, isRegistered) => dispatch(Actions.sendOtpPhone(username, isRegistered)),
    changeValidationResponseType: (str) => dispatch(Actions.changeValidationResponseType(str)),

    changeMagicLinkStatus: (status) => dispatch(Actions.changeMagicLinkStatus(status)),
    handleVerifyUnRegisteredOtp: (username, otp, isUpdating) => dispatch(Actions.handleVerifyUnRegisteredOtp(username, otp, isUpdating)),
    resetLoginResponse: () => dispatch(Actions.resetLoginResponse())
});


export default connect(mapStateToProps, mapDispatchToProps)(Auth)